import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { MobileLinksDTO } from '@signature-it/ngx-generic/models';
import { MenuNavigationService, LanguageService, AuthService, EventBusService } from '@signature-it/ngx-generic/services';
import { MainHeaderNavbarMobileTopComponentGeneric } from "./top/navbar-mobile-top";
import { MainHeaderNavbarMobileSideComponentGeneric } from "./side/navbar-mobile-side";
import {IUser} from '@signature-it/ngx-generic/interfaces';
import { EventName } from '@signature-it/ngx-generic/classes';

declare let $: any;
declare let _: any;
declare let sessionStorage: any;

@Component({
    selector: 'main-header-navbar-mobile',
    templateUrl: './navbar-mobile.component.html',
    styleUrls: ['./navbar-mobile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MainHeaderNavbarMobileComponentGeneric {
    @ViewChild(MainHeaderNavbarMobileTopComponentGeneric, {static: true})  nbTop: MainHeaderNavbarMobileTopComponentGeneric;
    @ViewChild(MainHeaderNavbarMobileSideComponentGeneric, {static: true}) nbSide: MainHeaderNavbarMobileSideComponentGeneric;

    readonly CLASS_SIDENAV_SHOW = 'mat-sidenav-show';

    menuList: MobileLinksDTO[] = [];
    top: MobileLinksDTO[] = [];
    side: MobileLinksDTO[] = [];
    aboveTop: MobileLinksDTO[] = [];
    belowTop: MobileLinksDTO[] = [];
    account: MobileLinksDTO[] = [];
    logo: object;
    isOpen: boolean = false;
    user: IUser;

    entity_type: string = "";
    constructor(protected navSvc: MenuNavigationService,
                protected langSvc: LanguageService,
                protected authSvc: AuthService,
                protected eventBusService: EventBusService) {
    }

    ngOnInit() {
        this.authSvc
            .usersData$
            .subscribe(
                (user: IUser) => {
                    if(user){
                        this.user = user;
                        if(user.entity_type == "b2b-master"){
                            this.entity_type = "b2b_account";
                        }
                        else if(user.entity_type == "B2C"){
                            this.entity_type = "b2c_account";
                        }
                        const lang = this.langSvc.getCurrentLanguage();
                        if(sessionStorage.getItem('mobileLinks')){
                            let mobileLinks = JSON.parse(sessionStorage.getItem('mobileLinks'));
                            this.setMobileLinks(mobileLinks);
                        }else {
                            this.navSvc
                                .getMobileNavigation( lang )
                                .subscribe(
                                    ( menuList : MobileLinksDTO[] ) => {
                                        this.setMobileLinks(menuList);
                                        sessionStorage.setItem('mobileLinks', JSON.stringify(menuList));
                                    });
                        }
                    }

                }
            );
        this.eventBusService.on(EventName.MENU_NAVIGATE, completed => {
            if(this.isOpen){
                this.onSidebarToggle();
            }
        });
    }

    setMobileLinks(menuList: MobileLinksDTO[]){
        this.menuList = menuList;
        if(this.menuList.length) {
            // top
            if(this.nbTop) {
                this.top = this.sortMobileLinksByLocation(this.nbTop.ATTR_TOP)
                this.aboveTop = this.sortMobileLinksByLocation(this.nbTop.ATTR_ABOVE_TOP);
                this.belowTop = this.sortMobileLinksByLocation(this.nbTop.ATTR_BELOW_TOP);
                // logo in top
                const logo = _.filter( this.menuList, { [ MobileLinksDTO.ATTR_LOCATION ] : this.nbTop.ATTR_LOGO } );
                this.logo = {
                    collapsed : _.filter( logo, { [ MobileLinksDTO.ATTR_TYPE ] : this.nbTop.ATTR_LOGO_COLLAPSED } )[ 0 ] || {},
                    expanded : _.filter( logo, { [ MobileLinksDTO.ATTR_TYPE ] : this.nbTop.ATTR_LOGO_EXPANDED } )[ 0 ] || {}
                };
            }
            // side
            if(this.nbSide) {
                this.side = this.sortMobileLinksByLocation(this.nbSide.ATTR_SIDE, true);
            }

            //account
            this.account = this.sortMobileLinksByLocation(this.entity_type);
        }

    }

    onSidebarToggle() {
        $('body').toggleClass(this.CLASS_SIDENAV_SHOW);
        this.isOpen = !this.isOpen;
    }

    onSidebarClick($event) {
        if ($event.target.localName === 'main-header-navbar-mobile-side') {
            this.onSidebarToggle();
        }
    }

    sortMobileLinksByLocation(location, checkIsLogin = false) {
        if(checkIsLogin && this.user.user_id == -1){
            return _.sortBy(
                _.filter( this.menuList, { [ MobileLinksDTO.ATTR_LOCATION ] : location , [MobileLinksDTO.ATTR_IS_LOGIN] : 0 } ),
                MobileLinksDTO.ATTR_ORDER
            );
        }
        else{
            return _.sortBy(
                _.filter( this.menuList, { [ MobileLinksDTO.ATTR_LOCATION ] : location } ),
                MobileLinksDTO.ATTR_ORDER
            );
        }
    }

}
